import { useRouter } from 'next/router';
import { EcoSpecSelectorType } from 'eco-design/sections/eco-spec-selector/type';
import { EcoSelectorItemType } from 'eco-design/base/eco-selector/typs';
import { generalKeys } from '../config/page';
import { useProduct } from '../ProductProvider';
import { getProductDetail } from '@/service/ProductCommon/getProductDetail';
import { formatSpecs } from '@/utils/product-common/formatSpecs';

const generalMap: Record<string, string> = {
    product_ps_delta_delta_3_u: '/delta-3-ultra-series-portable-power-station-',
    product_ps_delta_delta_3_u_p: 'delta-3-ultra-series-portable-power-station',
};
export default function getProductSpec(title: string, theme: 'white' | 'black') {
    const { state, dispatch } = useProduct();
    const { productSpecs } = state;
    const { locale = 'us' } = useRouter();

    const getData = async (generalKey: string) => {
        return await new Promise(async (resolve, reject) => {
            const res = await getProductDetail(generalMap[generalKey], locale);
            if (res?.code === '0') {
                resolve({ productCatagory: res?.data?.productCatagoryResponseList, productDetail: res?.data?.spuResponse });
            } else {
                reject(res?.message);
            }
        });
    };

    const formarSpecSeletorItems = (productSpecs: any[]) => {
        const arr = [] as EcoSelectorItemType[];
        productSpecs?.map((sp: any) => {
            sp?.productDetail?.skuList?.map((sk: any) => {
                arr.push({
                    label: sk.name,
                    value: sk.name,
                });
            });
        });
        return arr;
    };

    if (!productSpecs) {
        const promises: any[] = [];
        generalKeys.map((generalKey: string) => promises.push(getData(generalKey)));
        Promise.all(promises).then((payload: any[]) => {
            const specs: EcoSpecSelectorType = {
                title,
                theme,
                selector: {
                    items: formarSpecSeletorItems(payload),
                },
                items: formatSpecs(payload) || [],
            };
            dispatch({
                type: 'changeProductSpec',
                payload: specs,
            });
        });
    }

    return null;
}
